export const PROMPT_TYPES = {
  SYSTEM: "system-prompt",
  USER: "user-prompt",
  INTERPRETATION: "interpretation-prompt",
};
